<template>
    <div class="literacy_content">
        <div class="header">
            <div class="tab_box">
                <div
                    class="tab_item"
                    :class="activeTabItem == item.id ? 'active_tab_item' : ''"
                    v-for="item in tablist"
                    :key="item.id"
                    @click="clickTab(item.id)"
                >
                    {{ item.name }}
                </div>
            </div>
            <el-button v-if="activeTabItem == 2" type="primary" size="medium" @click="addRules">
                新建细项
            </el-button>
        </div>
        <div class="content">
            <LiteracyEvaluationModule v-if="activeTabItem === 1" />
            <LiteracyAssessmentDetails ref="literacyAssessmentDetailsRef" v-else-if="activeTabItem === 2" />
        </div>
    </div>
</template>

<script>
import LiteracyEvaluationModule from "./component/LiteracyEvaluationModule.vue";
import LiteracyAssessmentDetails from "./component/LiteracyAssessmentDetails.vue";
export default {
    name: "teacherMatingDetail",
    data() {
        return {
            tablist: [
                { name: "素养评价", id: 1 },
                { name: "素养评定细则", id: 2 },
            ],
            activeTabItem: 1,
        };
    },

    components: {
        LiteracyEvaluationModule,
        LiteracyAssessmentDetails,
    },
    methods: {
        clickTab(id) {
            this.activeTabItem = id;
        },
        addRules() {
            this.$nextTick(() => {
                this.$refs.literacyAssessmentDetailsRef.newRegulation();
            });
        },
    },
};
</script>

<style scoped lang="scss">
.literacy_content {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;

    .header {
        width: 100%;
        padding: 0 44px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        .tab_box {
            display: flex;
            .tab_item {
                padding: 18px 0;
                margin-right: 46px;
                border-bottom: 2px solid transparent;
                cursor: pointer;
            }
            .active_tab_item {
                color: #006eff;
                border-bottom: 2px solid #006eff;
            }
        }
    }
    .content {
        width: 100%;
        height: calc(100vh - 212px);
        padding: 0 44px;
        box-sizing: border-box;
        overflow-y: auto;
    }
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
    width: 3px; /* 滚动条宽度 */
    height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #d3d2d2; /* 滑块背景色 */
    border-radius: 6px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
    background: #555; /* 滑块悬停背景色 */
}
</style>
